import dayjs from "dayjs";

/**
 * 日期统一约定：
 * - 存库：所选日期的「北京时间 13:00」（= UTC 05:00 = 老挝时间 12:00）
 * - 展示：按北京时间取「日期」，不显示具体时间点
 * - 选择器：DatePicker 的值用「本地 0 点的 dayjs」，仅代表日期标签
 * 北京无夏令时，固定 UTC+8，不依赖 dayjs 的 utc/timezone 插件。
 */
const BJ_OFFSET_MS = 8 * 60 * 60 * 1000;

// 选择器的值(dayjs) -> 入库值（北京时间 13:00 的 Date）
export function toBjNoon(d) {
  if (!d) return null;
  const x = dayjs(d);
  if (!x.isValid()) return null;
  return new Date(Date.UTC(x.year(), x.month(), x.date(), 5, 0, 0));
}

// 库里的值 -> 选择器的值/日期标签（本地 0 点的 dayjs，只代表日期）
export function fromBj(v) {
  if (!v) return null;
  const t = new Date(v).getTime();
  if (Number.isNaN(t)) return null;
  const b = new Date(t + BJ_OFFSET_MS);
  return dayjs(new Date(b.getUTCFullYear(), b.getUTCMonth(), b.getUTCDate()));
}

// 展示用：只取北京时间日期
export function fmtBj(v, fmt = "YYYY-MM-DD") {
  const d = fromBj(v);
  return d ? d.format(fmt) : "-";
}

// 今天（本地日期标签，0 点）
export const today = () => dayjs().startOf("day");

// 距今天数：>0 还有N天，0 今天，<0 已逾期N天
export function daysFromToday(v) {
  const d = fromBj(v);
  return d ? d.diff(today(), "day") : null;
}

// 账单日状态，规则按「日期」而不是时刻：当天不算逾期
export function dueInfo(v, warnDays = 7) {
  const days = daysFromToday(v);
  if (days === null) return { days: null, status: "none" };
  if (days < 0) return { days, status: "overdue" };
  if (days <= warnDays) return { days, status: "warning" };
  return { days, status: "normal" };
}

// 金额保留两位，避免浮点误差
export const r2 = (v) => Math.round((Number(v) + Number.EPSILON) * 100) / 100;
